import {
  configureStore,
  ThunkAction,
  Action,
  AnyAction,
  combineReducers,
  Reducer,
} from "@reduxjs/toolkit";
import coreReducer from "core/redux/index";
import usersFeatureReducer from "features/users/redux/index";
import dashboardFeatureReducer from "features/dashboard/redux/index";
import surveyFeatureReducer from "features/survey/redux/index";
import commentsFeatureReducer from "features/comments/redux/index";
import notificationsReducer from "features/notifications/redux/index"
import pageReducer from "features/page/redux/index"
import { Middleware } from "@reduxjs/toolkit";

export const throwMiddleware: Middleware = () => (next) => (action) => {
  next(action);
  if (action?.error) {
    throw action.payload;
  }
};

const combinedReducer = combineReducers({
  core: coreReducer,
  users: usersFeatureReducer,
  dashboard: dashboardFeatureReducer,
  survey: surveyFeatureReducer,
  comments: commentsFeatureReducer,
  notifications: notificationsReducer,
  page: pageReducer
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === "user/logout") {
    state = {} as RootState;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(throwMiddleware),
});

export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
